'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const ORDER_LOOKUP = '';
const ITEM_SELECTION = '/item/selection';
const ITEM_REMOVE_CONFIRMATION = '/item/remove';
const ITEM_QUANTITY = '/item/quantity';
const ITEM_PHOTO = '/item/photo';
const ITEM_ADDITIONAL_INFO = '/item/additional-info';
const ITEM_CLAIM_SUMMARY = '/item/summary';
const PACKAGE_SELECTION = '/package/selection';
const PACKAGE_REMOVE_CONFIRMATION = '/package/remove';
const PACKAGE_ADDITIONAL_INFO = '/package/additional-info';
const PACKAGE_CLAIM_SUMMARY = '/package/summary';
const CONFIRMATION = '/confirmation';

exports.CONFIRMATION = CONFIRMATION;
exports.ITEM_ADDITIONAL_INFO = ITEM_ADDITIONAL_INFO;
exports.ITEM_CLAIM_SUMMARY = ITEM_CLAIM_SUMMARY;
exports.ITEM_PHOTO = ITEM_PHOTO;
exports.ITEM_QUANTITY = ITEM_QUANTITY;
exports.ITEM_REMOVE_CONFIRMATION = ITEM_REMOVE_CONFIRMATION;
exports.ITEM_SELECTION = ITEM_SELECTION;
exports.ORDER_LOOKUP = ORDER_LOOKUP;
exports.PACKAGE_ADDITIONAL_INFO = PACKAGE_ADDITIONAL_INFO;
exports.PACKAGE_CLAIM_SUMMARY = PACKAGE_CLAIM_SUMMARY;
exports.PACKAGE_REMOVE_CONFIRMATION = PACKAGE_REMOVE_CONFIRMATION;
exports.PACKAGE_SELECTION = PACKAGE_SELECTION;
